import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Typo from 'uikit/content/components/typo';

import styles from '../styles/uikitDurationDuration.module.scss';

const Duration = ({ duration = 0, className = '' }) => {
  const calculateDuration = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time - minutes * 60;

    return {
      minutes,
      seconds,
    };
  };

  const { minutes, seconds } = calculateDuration(duration);

  return (
    <div className={classnames(styles.element, className)}>
      <div className={styles.text}>
        <Typo color="inherit" variant="s01">
          {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
        </Typo>
      </div>
    </div>
  );
};

Duration.propTypes = {
  duration: PropTypes.number,
  className: PropTypes.string,
};

export default Duration;
